module.exports = __webpack_public_path__ + "img/rotationHelper.2e21d37f.svg";